import { ApplicationConfig } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { isKioskUrl } from '@core/helpers/is-kiosk-url';
import { mockKeycloakServiceProvider } from '@core/providers/mock-keycloak-service-provider';
import { CONFIG_TOKEN } from '@core/tokens';
import { Config } from '@core/types';

import { environment } from '@environments/environment';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

document.addEventListener('DOMContentLoaded', async () => {
  try {
    const response = await fetch('config.json');
    const config: Config = await response.json();

    const extendedConfig: Config = {
      apiIsMocked: config.apiIsMocked ?? environment.apiIsMocked,
      backendRootUrl: config.backendRootUrl ?? environment.backendRootUrl,
      backendWebsocketUrl: config.backendWebsocketUrl ?? environment.backendWebsocketUrl,
      mapboxToken: config.mapboxToken,
      keycloak: config.keycloak,
      kioskKeycloak: config.kioskKeycloak,
      googleTagManagerId: config.googleTagManagerId,
      posthog: config.posthog,
      appVersionTag: config.appVersionTag,
      appEnvironmentId: config.appEnvironmentId,
      temporalWebUiUrl: config.temporalWebUiUrl,
    };
    const extendedAppConfig: ApplicationConfig = {
      ...appConfig,
      providers: [
        ...appConfig.providers,
        {
          provide: CONFIG_TOKEN,
          useValue: extendedConfig,
        },
        ...((isKioskUrl() ? extendedConfig.kioskKeycloak.mocked : extendedConfig.keycloak.mocked) ? [mockKeycloakServiceProvider] : []),
      ],
    };

    if (extendedConfig.apiIsMocked) {
      const { worker } = await import('./mocks/browser');
      await worker(extendedConfig.backendRootUrl, extendedConfig.backendWebsocketUrl).start({
        serviceWorker: { url: '/mockServiceWorker.js' },
      });
    }

    await bootstrapApplication(AppComponent, extendedAppConfig);
  } catch (error) {
    console.error(error);
  }
});
